import React from "react";
import PdfViewer from "../comman/PdfViewer";
import { marketingDocs } from "../consfig";

const TipkitOnePager = () => {
  const pdfUrl = marketingDocs.tipkitOnePager;

  return <PdfViewer pdfFile={pdfUrl} />;
};

export default TipkitOnePager;
